export default __webpack_public_path__ + "static/media/profile.820deb9a.jpeg";